<template lang="pug">
  b-modal(
    :visible="visible"
    title="接続先ポップアップを選択"
    size="lg"
    hide-footer
    @hide="$emit('close')"
  )
    .mb-3
      label 検索：
      input.form-control(
        v-model="searchQuery"
        placeholder="シナリオ名で検索"
      )
    .popup-list
      .test-center.text-muted.py-4(v-if="filteredOptions.length === 0") 
        | 接続先に設定できるポップアップがありません
      .popup-card.d-flex.align-items-center.border.rounded.p-3.mb-3(
        v-else
        v-for="popup in filteredOptions"
        :key="popup.id"
        :class="{ 'border-primary': popup.id === currentPopupId }"
        @click="$emit('select', popup.id)"
        style="cursor: pointer;"
      )
        .popup-thumbnail.mr-3(style="width: 120px; flex-shrink: 0;")
          img.img-fluid(v-if="popup.thumbnail_url" :src="popup.thumbnail_url")
          .bg-secondary.d-flex.align-items-center.justify-content-center(
            v-else
            style="width: 120px; height: 80px; color: white; font-size: 12px;"
          ) サムネイル
        .popup-info.flex-grow-1
          div
            strong {{ popup.name }}
          div.text-muted.small.mt-1
            | 設問数：{{ popup.questions_count }}　|　回答シナリオ数：{{ popup.answers_count }}
          div.text-muted.small
            | 接続状況：{{ popup.connected_from.length ? popup.connected_from.join('、') : 'なし' }}
</template>

<script>
export default {
  name: 'ScenarioPopupSelectionModal',
  props: {
    visible: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    currentPopupId: { default: null },
    sourcePopupId: { default: null }
  },
  data() {
    return { searchQuery: '' }
  },
  computed: {
    filteredOptions() {
      return this.options
        .filter(p => p.id !== Number(this.sourcePopupId))
        .filter(p => !this.searchQuery || p.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
    }
  }
}
</script>

<style scoped>
.popup-card:hover {
  background-color: #f0f4ff;
}
.popup-card.border-primary {
  background-color: #e6edff;
}
.popup-card.border-primary:hover {
  background-color: #d6e4ff;
}
</style>
